var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { InstructionType } from 'packages/bot/entities/ConversationNodeInstruction';
import Vue from 'vue';
export var mutations = {
    setLoadingState: function (state, loading) {
        state.loading = loading;
    },
    setBot: function (state, id) {
        state.id = id;
    },
    setCurrentConversation: function (state, conversationId) {
        state.currentConversationId = conversationId;
    },
    pushInstruction: function (state, instruction) {
        state.instructionBufferStack.push(instruction);
    },
    moveFromBufferToRenderStack: function (state) {
        var instruction = state.instructionBufferStack.shift();
        state.instructionBufferStack = __spreadArray([], state.instructionBufferStack);
        state.renderStack.push(instruction);
        state.renderStack = __spreadArray([], state.renderStack);
    },
    setValueOnLatestInstruction: function (state, message) {
        var lastMessage = state.renderStack.pop();
        lastMessage.type = InstructionType.COLLECT;
        // ensure vue will track this, since the `value` property didn't exist first
        Vue.set(lastMessage.data, 'value', message);
        state.renderStack = __spreadArray(__spreadArray([], state.renderStack), [lastMessage]);
    },
    setTyping: function (state, instructionId) {
        state.isTypingMessage = instructionId;
    },
};
export var types = {
    SET_LOADING: 'setLoadingState',
    SET_BOT: 'setBot',
    SET_CURRENT_CONVERSATION: 'setCurrentConversation',
    PUSH_INSTRUCTION: 'pushInstruction',
    SHIFT_INSTRUCTION: 'shiftInstruction',
    MOVE_INSTRUCTION: 'moveFromBufferToRenderStack',
    POP_AND_PUSH_RENDER: 'setValueOnLatestInstruction',
    SET_TYPING: 'setTyping',
};
